export default {
  root: {
    width: '100%',
    height: '100%'
  }
};
